import { createAsyncThunk } from '@reduxjs/toolkit';
import * as authApi from '../../../api/auth'



export const userLogin = createAsyncThunk(
    "auth/login",
    async (data) => {
        const res = await authApi.login({ data: data });
        return res.data;
    }
);

export const getNewToken = createAsyncThunk(
    "auth/refresh-token",
    async (data) => {
        let config = { data }
        const res = await authApi.refreshToken(config);
        return res.data;
    }
);